export default __webpack_public_path__ + "static/media/animal-embassy-logo.4eb2d8cb.png";